import { Module } from "wrapper6";

var $ = jQuery;

export default class Modal extends Module {
	ready(app) {
		// Show interest modal
        new MTTModal('interest-modal', '.open-interest-modal', true);
    }
}

class MTTModal {

    constructor(ELEMENT, SELECTOR, onclick = false) {
        // Get element
        this.ELEMENT = document.getElementById(ELEMENT);
        if (!this.ELEMENT) return;

        // Get open buttons
        this.OPEN_BUTTONS = document.querySelectorAll(SELECTOR);
        if (this.OPEN_BUTTONS.length === 0) return;

        // On click
        this.onclick = onclick;

        // Get close buttons
        this.CLOSE_BUTTONS = document.querySelectorAll('.mtt-modal__close, .mtt-modal__overlay');

        // Add event listeners
        this.eventListeners();
    }

    eventListeners() {
        // Open modal
        for (let i = 0; i < this.OPEN_BUTTONS.length; i++) {
            this.OPEN_BUTTONS[i].addEventListener('click', () => {
                this.openModal();
                this.onclick && this.clickEvent(this.OPEN_BUTTONS[i]);
            });
        }
        
        // Close modal
        if (this.CLOSE_BUTTONS.length) {
            for (let i = 0; i < this.CLOSE_BUTTONS.length; i++) {
                this.CLOSE_BUTTONS[i].addEventListener('click', this.closeModal.bind(this));
            }
        }
        
        // Close on escape
        document.addEventListener('keydown', (e) => {
            e.keyCode === 27 && this.ELEMENT.classList.contains('mtt-modal--show') ? this.closeModal() : ''
        })
    }
    
    openModal(currentButton) {
        event.preventDefault();
        this.ELEMENT.classList.add('mtt-modal--show');
    }
    
    closeModal() {
        this.ELEMENT.classList.remove('mtt-modal--show');
    }

    clickEvent(current) {
        const URL = current.getAttribute('data-url');
        const INPUT = document.querySelector('input[name="current-url"]');
        if (URL && INPUT) {
            INPUT.value = URL;
        }
    }
}